let ENTRIES = null;
const URL = window.siteConfig().comparisonServiceUrl;
const SITE_NAME = window.siteConfig().siteName;

const ComparisonServiceEvents = {
    UPDATE: 'ComparisonServiceEventsUpdate',
};

const add = async sku => {
    try {
        const response = await fetch(`${URL}/add/${SITE_NAME}?sku=${sku}`, {});
        const responseJson = await response.json();
        if (response.ok) {
            ENTRIES = new Set(responseJson || []);
            notifyUpdate();
        } else {
            throw responseJson;
        }
    } catch (e) {
        return e || false;
    }

    return ENTRIES;
};

const update = async () => {
    try {
        const response = await fetch(`${URL}/get/${SITE_NAME}`, {});
        ENTRIES = new Set((await response.json()) || []);
        notifyUpdate();
    } catch (e) {
        console.log('comparsion service GET error');
    }
    return ENTRIES;
};

const remove = async sku => {
    try {
        const response = await fetch(`${URL}/remove/${SITE_NAME}?sku=${sku}`);
        ENTRIES = new Set((await response.json()) || []);
        notifyUpdate();
    } catch (e) {
        console.log('comparsion service GET error');
    }
    return ENTRIES;
};

const get = async () => {
    if (!ENTRIES) {
        await update();
    }
    return ENTRIES;
};

const count = async () => {
    if (!ENTRIES) {
        await update();
    }
    return ENTRIES?.size || 0;
};

const set = UPDATE => {
    if (Array.isArray(UPDATE)) ENTRIES = new Set(UPDATE);
    notifyUpdate();
};

const has = async sku => {
    if (!ENTRIES) {
        await update();
    }
    return ENTRIES?.has(sku) ?? false;
};

const notifyUpdate = () => {
    const event = new CustomEvent(ComparisonServiceEvents.UPDATE, {
        detail: ENTRIES,
    });
    document.dispatchEvent(event);
};

const ComparisonService = {
    add,
    get,
    remove,
    has,
    set,
    count,
};

export { ComparisonService, ComparisonServiceEvents };
